import * as z from "zod/v4";
import {
  array,
  boolean,
  literal,
  number,
  object,
  string,
  enum as zodEnum,
} from "zod/v4";
import { ConfirmUpdateOrderSchema } from "../../agents/support-agents/confirm-update-order";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";

export const UpdateOrderCustomerInputContentSchema = object({
  confirmed: boolean().optional(),
  items: array(
    object({
      variantId: string().optional(),
      quantity: number().optional(),
      action: zodEnum(["add", "remove"]).optional(),
    }),
  ).optional(),
});

export const UpdateOrderMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.UPDATE_ORDER),
  structuredContent: ConfirmUpdateOrderSchema,
  customerInputContent: UpdateOrderCustomerInputContentSchema.optional(),
});

export const UpdateOrderMessageDbParser = UpdateOrderMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type UpdateOrderMessageType = z.infer<typeof UpdateOrderMessageDbParser>;
export type UpdateOrderMessageTypeWithoutId = WithoutId<UpdateOrderMessageType>;
